import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/ui/password-input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { PasswordStrengthMeter, FieldError } from "@/components/FormFeedback";
import { cn } from "@/lib/utils";

// "Reset Password for {staff}" dialog — new temp password + confirm.
export default function ResetStaffPasswordDialog({
  open,
  onOpenChange,
  selectedStaff,
  newPassword,
  setNewPassword,
  newPasswordConfirm,
  setNewPasswordConfirm,
  resetTouched,
  setResetTouched,
  resetFieldErrors,
  resetIsValid,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reset-staff-password-modal">
        <DialogHeader>
          <DialogTitle>Reset Password for {selectedStaff?.name}</DialogTitle>
          <DialogDescription>Set a new temporary password. They will be asked to change it on next login.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>New Temporary Password</Label>
            <PasswordInput testId="reset-staff-password-input" value={newPassword} onBlur={() => setResetTouched((t) => ({ ...t, newPassword: true }))} className={cn(resetTouched.newPassword && resetFieldErrors.newPassword && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setNewPassword(e.target.value)} />
            <PasswordStrengthMeter password={newPassword} />
            {resetTouched.newPassword && <FieldError testId="reset-staff-password-error" message={resetFieldErrors.newPassword} />}
          </div>
          <div>
            <Label>Confirm New Password</Label>
            <PasswordInput testId="reset-staff-password-confirm-input" value={newPasswordConfirm} onBlur={() => setResetTouched((t) => ({ ...t, newPasswordConfirm: true }))} className={cn(resetTouched.newPasswordConfirm && resetFieldErrors.newPasswordConfirm && "border-red-500 focus-visible:ring-red-500")} onChange={(e) => setNewPasswordConfirm(e.target.value)} />
            {resetTouched.newPasswordConfirm && <FieldError testId="reset-staff-password-confirm-error" message={resetFieldErrors.newPasswordConfirm} />}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="reset-staff-password-submit-btn" disabled={!resetIsValid} className="bg-teal-700 hover:bg-teal-800" onClick={onSubmit}>Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
